import { ReactComponent as OrgChart } from './icon.svg'

export default OrgChart
